import { Container, Grid } from "@mui/material";
import ScreenBanner from "../../components/ScreenBanner";
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../components/ListaAcoesRapidas";
import { useNavigate } from "react-router";
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import PermissionGuard, { usePermission } from "../../components/PermissionGuard";

export default function Fiscal() {

    const navigate = useNavigate();
    
    const listaAcoesRapidas: Array<TItemAcaoRapida> = [
        {
            label: "Listar notas fiscais",
            icon: <ListOutlinedIcon color="primary" />,
            action: () => navigate('/fiscal/notas-fiscais/listar-todas'),
            havePermission: usePermission('fiscal.notas-fiscais.listar-todas')
        },
    ]

    return (
        <>
            <ScreenBanner title="Fiscal" />

            <PermissionGuard permissionId="fiscal.dashboard">
                <Container>
                    <Grid container spacing={2} mt={2}>
                        <Grid size={{xs: 12, md: 4}}>
                            <ListaAcoesRapidas
                                items={listaAcoesRapidas}
                            />
                        </Grid>

                        <Grid size={{xs: 12, md: 8}}>
                            {/* <CardDadosDashboard /> */}
                        </Grid>

                        <Grid size={{xs: 12, md: 6}}>
                            {/* <CardCobrancas /> */}
                        </Grid>

                        <Grid size={{xs: 12, md: 6}}>
                            {/* <CardFluxoCaixa /> */}
                        </Grid>
                    </Grid>
                </Container>
            </PermissionGuard>
        </>
    )
}